const VATValidation = ( $ ) => {

	function toggleVatFields() {
		const $checkboxes = $( '#vat_invoice_needed, #billing_vat_invoice_needed, #order-iwpdev-antara-vat-number-checkbox, [id*=\'vat-invoice-needed\']' );
		let isChecked = false;

		$checkboxes.each( function() {
			if ( $( this ).is( ':checked' ) ) isChecked = true;
		} );

		// Fallback check: if any VAT field is visible, we might consider it active
		if ( ! isChecked ) {
			const $vatFields = $( '#order-iwpdev-antara-vat-number, #vat_number, #billing_vat_number, [id*=\'vat-number\']' );
			$vatFields.each( function() {
				if ( $( this ).is( ':visible' ) ) {
					isChecked = true;
				}
			} );

			if ( ! isChecked ) {
				const $vatFieldContainer = $vatFields.closest( '.vat-field' );
				if ( $vatFieldContainer.length && $vatFieldContainer.hasClass( 'show' ) ) {
					isChecked = true;
				}
			}
		}

		if ( isChecked ) {
			$( '.vat-field' ).addClass( 'show' );
			$( '.vat-field' ).find( 'input, textarea' ).attr( 'required', 'required' );
		} else {
			$( '.vat-field' ).removeClass( 'show' );
			$( '.vat-field' ).find( 'input, textarea' ).removeAttr( 'required' );
		}
	}

	async function validateVatNumber( vatNumber ) {
		if ( ! vatNumber ) return { valid: false, message: 'VAT number is required' };

		// Clean VAT number (remove spaces, dots, dashes)
		const cleanedVat = vatNumber.replace( /[ \.\-\/]/g, '' ).toUpperCase();

		try {
			// Determine the AJAX URL
			const ajaxUrl = ( typeof vatValidationConfig !== 'undefined' && vatValidationConfig.ajax_url )
				? vatValidationConfig.ajax_url
				: '/wp-admin/admin-ajax.php';


			// Set a timeout for the fetch request
			const controller = new AbortController();
			const timeoutId = setTimeout( () => controller.abort(), 12000 ); // Slightly longer timeout for server-side proxy

			const response = await fetch( ajaxUrl + '?action=validate_vat_number&vat_number=' + encodeURIComponent( cleanedVat ), {
				signal: controller.signal
			} );

			clearTimeout( timeoutId );

			if ( ! response.ok ) {
				return { valid: false, message: 'Validation service temporarily unavailable' };
			}

			const result = await response.json();

			if ( result.success && result.data ) {
				// We expect the data from Vatly to be in result.data or result.data.data depending on API version
				const vatlyData = result.data.data || result.data;
				return {
					valid: vatlyData.valid,
					message: vatlyData.valid ? 'Valid VAT number' : 'Invalid VAT number format or non-existent'
				};
			} else if ( result.success === false ) {
				return {
					valid: false,
					message: result.data && result.data.message ? result.data.message : 'Validation error'
				};
			}

			return { valid: false, message: 'Invalid response from server' };
		} catch ( error ) {

			if ( error.name === 'AbortError' ) {
				return { valid: false, message: 'Validation service timeout' };
			}

			// Check if it's a fetch error (network, CORS)
			if ( error instanceof TypeError && error.message === 'Failed to fetch' ) {
				return { valid: false, message: 'Network error or blocked by browser. Please check your connection.' };
			}

			return {
				valid: false,
				message: 'Validation service unavailable (' + ( error.message || 'Unknown error' ) + ')'
			};
		}
	}

	$( document.body ).on( 'change', '#order-iwpdev-antara-vat-number, #vat_invoice_needed, #billing_vat_invoice_needed, #order-iwpdev-antara-vat-number-checkbox, [id*=\'vat-invoice-needed\'], [id*=\'vat-number\']', function() {
		toggleVatFields();
	} );

	// Listen for woocommerce updated_checkout which happens during AJAX updates
	$( document.body ).on( 'updated_checkout', function() {
		toggleVatFields();
	} );

	toggleVatFields();

	$( document.body ).on( 'checkout_place_order', function() {
		const $checkboxes = $( '#vat_invoice_needed, #billing_vat_invoice_needed, #order-iwpdev-antara-vat-number-checkbox, [id*=\'vat-invoice-needed\']' );
		let isChecked = false;
		$checkboxes.each( function() {
			if ( $( this ).is( ':checked' ) ) isChecked = true;
		} );

		// Fallback for final check
		if ( ! isChecked ) {
			const $vatFields = $( '#order-iwpdev-antara-vat-number, #vat_number, #billing_vat_number, [id*=\'vat-number\']' );
			$vatFields.each( function() {
				if ( $( this ).is( ':visible' ) ) isChecked = true;
			} );

			if ( ! isChecked ) {
				const $vatField = $vatFields.closest( '.vat-field' );
				if ( $vatField.length && $vatField.hasClass( 'show' ) ) {
					isChecked = true;
				}
			}
		}

		if ( ! isChecked ) {
			return true;
		}

		const vatNumber = $( '#vat_number, #billing_vat_number, #order-iwpdev-antara-vat-number, [id*=\'vat-number\']' ).filter( ':visible' ).first().val() || $( '#vat_number, #billing_vat_number, #order-iwpdev-antara-vat-number, [id*=\'vat-number\']' ).first().val();
		if ( ! vatNumber ) {
			return true;
		}

		if ( $( '#checkout-form-vat-validated' ).val() === '1' ) {
			return true;
		}

		const $form = $( 'form.checkout' );
		$form.addClass( 'processing' ).block( {
			message: null,
			overlayCSS: {
				background: '#fff',
				opacity: 0.6
			}
		} );

		validateVatNumber( vatNumber ).then( result => {
			if ( result.valid ) {
				if ( $( '#checkout-form-vat-validated' ).length === 0 ) {
					$form.append( '<input type="hidden" id="checkout-form-vat-validated" value="1">' );
				} else {
					$( '#checkout-form-vat-validated' ).val( '1' );
				}
				$form.submit();
			} else {
				$form.removeClass( 'processing' ).unblock();
				const errorMessage = result.message || 'Invalid VAT number';

				if ( typeof Swal !== 'undefined' ) {
					Swal.fire( {
						title: 'VAT Error',
						html: errorMessage + '<br><br><small>If you are sure the VAT is correct, please try again or contact support.</small>',
						icon: 'error',
						confirmButtonColor: '#000'
					} );
				}

				$( '.woocommerce-error.vat-error' ).remove();

				const $errorHtml = $( '<ul class="woocommerce-error vat-error" role="alert"><li>' + errorMessage + '</li></ul>' );
				if ( $( '.woocommerce-notices-wrapper' ).length ) {
					$( '.woocommerce-notices-wrapper' ).first().prepend( $errorHtml );
				} else {
					$form.prepend( $errorHtml );
				}

				$( 'html, body' ).animate( {
					scrollTop: ( $( '.woocommerce-error.vat-error' ).offset().top - 100 )
				}, 1000 );
			}
		} ).catch( ( err ) => {
			$form.removeClass( 'processing' ).unblock();
		} );

		return false;
	} );

	$( document.body ).on( 'change blur', '#vat_number, #billing_vat_number, #order-iwpdev-antara-vat-number, [id*=\'vat-number\']', function() {
		const $field = $( this );
		const vatNumber = $field.val();
		const $checkboxes = $( '#vat_invoice_needed, #billing_vat_invoice_needed, #order-iwpdev-antara-vat-number-checkbox, [id*=\'vat-invoice-needed\']' );
		let isChecked = false;
		$checkboxes.each( function() {
			if ( $( this ).is( ':checked' ) ) isChecked = true;
		} );

		// Fallback check
		if ( ! isChecked ) {
			if ( $field.is( ':visible' ) ) {
				isChecked = true;
			} else {
				const $vatField = $field.closest( '.vat-field' );
				if ( $vatField.length && $vatField.hasClass( 'show' ) ) {
					isChecked = true;
				}
			}
		}

		const $form = $( 'form.checkout' );

		$( '#checkout-form-vat-validated' ).val( '0' );

		if ( ! isChecked || ! vatNumber ) {
			return;
		}

		// Don't validate if it's already being validated or if it's already valid for the same value
		if ( $field.data( 'validating' ) ) {
			return;
		}

		$field.data( 'validating', true );

		// Show preloader
		const $fieldContainer = $field.closest( '.form-row' );
		if ( $fieldContainer.length ) {
			$fieldContainer.addClass( 'processing' ).block( {
				message: null,
				overlayCSS: {
					background: '#fff',
					opacity: 0.6
				}
			} );
		}

		validateVatNumber( vatNumber ).then( result => {
			$field.data( 'validating', false );
			if ( $fieldContainer.length ) {
				$fieldContainer.removeClass( 'processing' ).unblock();
			}
			if ( result.valid ) {
				if ( $( '#checkout-form-vat-validated' ).length === 0 ) {
					$form.append( '<input type="hidden" id="checkout-form-vat-validated" value="1">' );
				} else {
					$( '#checkout-form-vat-validated' ).val( '1' );
				}
				$( '.woocommerce-error.vat-error' ).remove();
			} else {
				$( '#checkout-form-vat-validated' ).val( '0' );
				// We don't necessarily want to show a popup on every blur if they are still typing,
				// but the user asked for validation when switching fields.
				// Let's at least show the error message in the notices.
				const errorMessage = result.message || 'Invalid VAT number';

				if ( typeof Swal !== 'undefined' ) {
					Swal.fire( {
						title: bricksChildData.vatTitle,
						html: bricksChildData.vatText + '<br><br><small>' + bricksChildData.vatSubText + '</small>',
						icon: 'error',
						confirmButtonColor: '#000',
						confirmButtonText: bricksChildData.vatButton,
					} );
				}

				$( '.woocommerce-error.vat-error' ).remove();
				const $errorHtml = $( '<ul class="woocommerce-error vat-error" role="alert"><li>' + errorMessage + '</li></ul>' );
				if ( $( '.woocommerce-notices-wrapper' ).length ) {
					$( '.woocommerce-notices-wrapper' ).first().prepend( $errorHtml );
				} else {
					$form.prepend( $errorHtml );
				}
			}
		} ).catch( ( err ) => {
			$field.data( 'validating', false );
			if ( $fieldContainer.length ) {
				$fieldContainer.removeClass( 'processing' ).unblock();
			}
		} );
	} );
};

export default VATValidation;
